import { render, staticRenderFns } from "./TableReportRefund.vue?vue&type=template&id=23fe976a&scoped=true"
import script from "./TableReportRefund.vue?vue&type=script&lang=js"
export * from "./TableReportRefund.vue?vue&type=script&lang=js"
import style0 from "./TableReportRefund.vue?vue&type=style&index=0&id=23fe976a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe976a",
  null
  
)

export default component.exports